import { ArrowLeft } from '#app/components/icons/solid'
import { useLocation } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/error-boundary.js'
import { Button } from './base/buttons/button'

export function IconSetErrorBoundary() {
	const location = useLocation()
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: () => (
					<div className="flex flex-col gap-6">
						<div className="flex flex-col gap-3">
							<h1>We can't find this page:</h1>
							<pre className="text-body-lg break-all whitespace-pre-wrap">
								{location.pathname}
							</pre>
						</div>
						<Button href="/" iconLeading={ArrowLeft}>
							Back to home
						</Button>
					</div>
				),
			}}
		/>
	)
}
